// extracted by mini-css-extract-plugin
export default {"container":"scrollbars_container__tkODH","vertical":"scrollbars_vertical__oLhQ3","multi":"scrollbars_multi__VVgCf","horizontal":"scrollbars_horizontal__YyZXS"};